/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  ApiRequestStatusClass,
  PublicApiRequestAudit,
  PublicApiRequestPage,
} from "../models/index";
import {
  ApiRequestStatusClassFromJSON,
  ApiRequestStatusClassToJSON,
  PublicApiRequestAuditFromJSON,
  PublicApiRequestAuditToJSON,
  PublicApiRequestPageFromJSON,
  PublicApiRequestPageToJSON,
} from "../models/index";

export interface ListForApiKeyRequest {
  apiKeyId: string;
  statusClass?: ApiRequestStatusClass | null;
  endpoint?: string | null;
  createdFrom?: string | null;
  createdTo?: string | null;
  page?: number | null;
  pageSize?: number | null;
}

export interface ListForCompanyRequest {
  companyId: string;
  apiKeyId?: string | null;
  statusClass?: ApiRequestStatusClass | null;
  endpoint?: string | null;
  createdFrom?: string | null;
  createdTo?: string | null;
  page?: number | null;
  pageSize?: number | null;
}

export interface ListForTraceIdRequest {
  traceId: string;
}

/**
 *
 */
export class PublicApiRequestsApi extends runtime.BaseAPI {
  /**
   */
  async listForApiKeyRaw(
    requestParameters: ListForApiKeyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PublicApiRequestPage>> {
    if (requestParameters["apiKeyId"] == null) {
      throw new runtime.RequiredError(
        "apiKeyId",
        'Required parameter "apiKeyId" was null or undefined when calling listForApiKey().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["apiKeyId"] != null) {
      queryParameters["apiKeyId"] = requestParameters["apiKeyId"];
    }

    if (requestParameters["statusClass"] != null) {
      queryParameters["statusClass"] = requestParameters["statusClass"];
    }

    if (requestParameters["endpoint"] != null) {
      queryParameters["endpoint"] = requestParameters["endpoint"];
    }

    if (requestParameters["createdFrom"] != null) {
      queryParameters["createdFrom"] = requestParameters["createdFrom"];
    }

    if (requestParameters["createdTo"] != null) {
      queryParameters["createdTo"] = requestParameters["createdTo"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    if (requestParameters["pageSize"] != null) {
      queryParameters["pageSize"] = requestParameters["pageSize"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/public-api-requests/list-for-api-key`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PublicApiRequestPageFromJSON(jsonValue),
    );
  }

  /**
   */
  async listForApiKey(
    requestParameters: ListForApiKeyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PublicApiRequestPage> {
    const response = await this.listForApiKeyRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async listForCompanyRaw(
    requestParameters: ListForCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PublicApiRequestPage>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling listForCompany().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["apiKeyId"] != null) {
      queryParameters["apiKeyId"] = requestParameters["apiKeyId"];
    }

    if (requestParameters["statusClass"] != null) {
      queryParameters["statusClass"] = requestParameters["statusClass"];
    }

    if (requestParameters["endpoint"] != null) {
      queryParameters["endpoint"] = requestParameters["endpoint"];
    }

    if (requestParameters["createdFrom"] != null) {
      queryParameters["createdFrom"] = requestParameters["createdFrom"];
    }

    if (requestParameters["createdTo"] != null) {
      queryParameters["createdTo"] = requestParameters["createdTo"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    if (requestParameters["pageSize"] != null) {
      queryParameters["pageSize"] = requestParameters["pageSize"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/public-api-requests/list-for-company`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PublicApiRequestPageFromJSON(jsonValue),
    );
  }

  /**
   */
  async listForCompany(
    requestParameters: ListForCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PublicApiRequestPage> {
    const response = await this.listForCompanyRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async listForTraceIdRaw(
    requestParameters: ListForTraceIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<PublicApiRequestAudit>>> {
    if (requestParameters["traceId"] == null) {
      throw new runtime.RequiredError(
        "traceId",
        'Required parameter "traceId" was null or undefined when calling listForTraceId().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["traceId"] != null) {
      queryParameters["traceId"] = requestParameters["traceId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/public-api-requests/list-for-trace-id`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(PublicApiRequestAuditFromJSON),
    );
  }

  /**
   */
  async listForTraceId(
    requestParameters: ListForTraceIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<PublicApiRequestAudit>> {
    const response = await this.listForTraceIdRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
